import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import map from 'lodash/map';
import get from 'lodash/get';
import toLower from 'lodash/toLower';
import difference from 'lodash/difference';
import { useSelector } from 'react-redux';
import sortBy from 'lodash/sortBy';
import FormGroup from 'components/Form/FormGroup';
import Select from 'components/Form/Select';
import App from 'modules/App';
import { usePatientProfileForm } from '../hooks';
import styles from './PhiSetFormPartial.pcss';
const desiredOrder = [
    'NoResponse',
    'Type1',
    'Type2',
    'GDM',
    'PreDiabetes',
    'NotSure',
    'NotSet'
];
const sortedOptions = ()=>sortBy(difference(App.constants.DIABETES_TYPES, App.constants.DIABETES_TYPES_HIDE_FOR_PWD_MOBILE), (item)=>{
        const index = desiredOrder.indexOf(item);
        return index === -1 ? Number.MAX_SAFE_INTEGER : index;
    });
const PhiSetFormPartial = ()=>{
    const localizationResources = useSelector(App.selectors.localizationResources);
    const { formValues, setFormValue } = usePatientProfileForm();
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.phiSetFormPartial,
        children: [
            /*#__PURE__*/ _jsx(FormGroup, {
                id: "diabetesType",
                labelMessage: App.messages.labels.diabetesType,
                formValues: formValues,
                children: /*#__PURE__*/ _jsx(Select, {
                    optionsFrom: map(sortedOptions(), (value)=>({
                            value,
                            label: get(localizationResources, `diabetesType_${toLower(value)}.value`, value)
                        })),
                    valueKey: "value",
                    labelKey: "label",
                    noValueMessage: App.messages.placeholders.diabetesType,
                    onChange: setFormValue
                })
            }),
            /*#__PURE__*/ _jsx(FormGroup, {
                id: "treatmentType",
                labelMessage: App.messages.labels.treatmentType,
                formValues: formValues,
                children: /*#__PURE__*/ _jsx(Select, {
                    optionsFrom: map(App.constants.TREATMENT_TYPES_MOBILE, (value)=>({
                            value,
                            label: get(localizationResources, `treatmentType_${toLower(value)}.value`, value)
                        })),
                    valueKey: "value",
                    labelKey: "label",
                    noValueMessage: App.messages.placeholders.treatmentType,
                    onChange: setFormValue
                })
            })
        ]
    });
};
export default PhiSetFormPartial;
